import { Component, OnInit, Inject } from '@angular/core';
import { ProdutoFechamento } from 'src/app/models/produto-fechamento';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FechamentoFinanceiroService } from 'src/app/services/fechamento-financeiro.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-produto-pedido-modal',
  templateUrl: './produto-pedido-modal.component.html',
  styleUrls: ['./produto-pedido-modal.component.scss']
})
export class ProdutoPedidoModalComponent implements OnInit {

  idCupom: number;
  produtos: ProdutoFechamento[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<void>,
    @Inject(MAT_DIALOG_DATA) public data: {idCupom: number},
    private fechamentoFinanceiroService: FechamentoFinanceiroService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService
  ) {
    this.idCupom = data.idCupom;
  }

  ngOnInit(): void {
    this.buscarProdutosDoPedido();
  }

  buscarProdutosDoPedido() {
    this.carregandoService.mostra('buscarProdutosDoPedido');

    this.fechamentoFinanceiroService.consultarProdutosDoPedido(this.idCupom).subscribe(
      (produtos: ProdutoFechamento[]) => {
        this.produtos = produtos;
        this.carregandoService.esconde('buscarProdutosDoPedido');
      },
      (err: Error) => {
        this.carregandoService.esconde('buscarProdutosDoPedido');
        this.notificacaoService.erro(err);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }
}
